/**
 * Spend by Project Chart
 * Bar chart comparing current vs previous month by project
 */

import BarChart from '@/components/charts/BarChart';
import type { ProjectSpend } from '../types';

interface SpendByProjectChartProps {
  data: ProjectSpend[] | null;
  currency: string;
}

export function SpendByProjectChart({ data, currency }: SpendByProjectChartProps) {
  if (!data || data.length === 0) {
    return null;
  }

  // Sort by current month spend
  const chartData = data
    .slice()
    .sort((a, b) => b.currentMonth - a.currentMonth)
    .map((item) => {
      const name = item.projectName ?? 'Unknown';
      return {
        name: name.length > 20 ? name.substring(0, 20) + '...' : name,
        'Current Month': item.currentMonth,
        'Previous Month': item.previousMonth,
      };
    });

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Spend by Project</h3>
      <div className="text-sm text-gray-500 mb-4">Current month vs previous month comparison</div>
      <BarChart
        data={chartData}
        xAxisKey="name"
        height={300}
        showLegend
        series={[
          { dataKey: 'Current Month', name: 'Current Month', color: '#3b82f6' },
          { dataKey: 'Previous Month', name: 'Previous Month', color: '#94a3b8' },
        ]}
      />
      <div className="mt-4 text-xs text-gray-500 text-right">
        Values in {currency}
      </div>
    </div>
  );
}
